import { Component } from '@angular/core';
import { MatIcon } from '@angular/material/icon';
import { forkJoin } from 'rxjs';
import { GlobalServerService, GlobalUnitService } from '@app/shared/services';

@Component({
	selector: 'sb-server-info',
	standalone: true,
	imports: [MatIcon],
	template: `
		<div class="server-info-component">
			<div>
				<mat-icon class="gray-image icon-size">info</mat-icon> Home Server Name:
				<label class="label-font">{{ homeServer }}</label>
			</div>
			<div>
				<mat-icon class="gray-image icon-size">info</mat-icon> Unit Server Name:
				<label class="label-font">{{ unitServer }}</label>
			</div>
			<div>
				<mat-icon class="gray-image icon-size">info</mat-icon> Unit Database Name:
				<label class="label-font">{{ unitDatabase }}</label>
			</div>
		</div>
	`,
	styleUrl: './server-info.component.less',
})
export class ServerInfoComponent {
	protected homeServer: string;
	protected unitServer: string;
	protected unitDatabase: string;

	constructor(private readonly globalServerService: GlobalServerService, private readonly globalUnitService: GlobalUnitService) {
		this.loadServerInfo();
	}

	private loadServerInfo(): void {
		const servers$ = this.globalServerService.getList();
		const homeServer$ = this.globalUnitService.getHomeDbServerName();
		const unitServer$ = this.globalUnitService.getUnitDbServerName();
		const unitDatabase$ = this.globalUnitService.getUnitDatabaseName();

		forkJoin([servers$, homeServer$, unitServer$, unitDatabase$]).subscribe(([servers, homeServer, unitServer, unitDatabase]) => {
			this.homeServer = homeServer.serverName;
			const homeServerLookup = servers.items.find((server) => server.ServerName === homeServer.serverName);
			if (homeServerLookup) {
				this.homeServer = homeServerLookup.DisplayName;
			}

			this.unitServer = unitServer.serverName;
			const unitServerLookup = servers.items.find((server) => server.ServerName === unitServer.serverName);
			if (unitServerLookup) {
				this.unitServer = unitServerLookup.DisplayName;
			}

			this.unitDatabase = unitDatabase.databaseName;
		});
	}
}
